var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewsettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3909_16168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90898 2.27273C4.90898 2.69949 4.56302 3.04545 4.13625 3.04545C3.70949 3.04545 3.36353 2.69949 3.36353 2.27273C3.36353 1.84596 3.70949 1.5 4.13625 1.5C4.56302 1.5 4.90898 1.84596 4.90898 2.27273ZM5.80823 2.86328C5.56498 3.55199 4.90824 4.04545 4.13625 4.04545C3.36426 4.04545 2.70753 3.55199 2.46427 2.86328H0V1.86328H2.41105C2.59586 1.08163 3.29813 0.5 4.13625 0.5C4.97438 0.5 5.67665 1.08163 5.86146 1.86328H13V2.86328H5.80823Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90898 11.6731C4.90898 12.0999 4.56302 12.4458 4.13625 12.4458C3.70949 12.4458 3.36353 12.0999 3.36353 11.6731C3.36353 11.2464 3.70949 10.9004 4.13625 10.9004C4.56302 10.9004 4.90898 11.2464 4.90898 11.6731ZM5.80823 12.2637C5.56498 12.9524 4.90824 13.4458 4.13625 13.4458C3.36426 13.4458 2.70753 12.9524 2.46427 12.2637H0V11.2637H2.41105C2.59586 10.482 3.29813 9.90039 4.13625 9.90039C4.97438 9.90039 5.67665 10.482 5.86146 11.2637H13V12.2637H5.80823Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63627 7.00027C9.63627 7.42703 9.29031 7.77299 8.86355 7.77299C8.43678 7.77299 8.09082 7.42703 8.09082 7.00027C8.09082 6.5735 8.43678 6.22754 8.86355 6.22754C9.29031 6.22754 9.63627 6.5735 9.63627 7.00027ZM10.5355 7.59082C10.2923 8.27953 9.63554 8.77299 8.86355 8.77299C8.09156 8.77299 7.43482 8.27953 7.19157 7.59082H0V6.59082H7.13834C7.32315 5.80917 8.02542 5.22754 8.86355 5.22754C9.70167 5.22754 10.4039 5.80917 10.5888 6.59082H13V7.59082H10.5355Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3909_16168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12.9998,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsettings);
export default __webpack_public_path__ + "static/media/viewsettings.ee25bef309880655341fd7a7cecf67ee.svg";
export { ForwardRef as ReactComponent };